var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('Drawer', {
    attrs: {
      "width": "400",
      "title": `${_vm.openedMaterial ? '编辑' : '新增'}${_vm.convertedType}`
    },
    model: {
      value: _vm.drawerOpened,
      callback: function ($$v) {
        _vm.drawerOpened = $$v;
      },
      expression: "drawerOpened"
    }
  }, [_c('div', {
    staticClass: "drawer-content"
  }, [_c('Form', {
    ref: "formItem",
    attrs: {
      "model": _vm.formItem,
      "rules": _vm.ruleValidate,
      "label-position": "top"
    },
    nativeOn: {
      "submit": function ($event) {
        $event.preventDefault();
      }
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "材料名",
      "prop": "name"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "输入材料名..."
    },
    model: {
      value: _vm.formItem.name,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "name", $$v);
      },
      expression: "formItem.name"
    }
  })], 1), _c('FormItem', {
    attrs: {
      "label": "型号",
      "prop": "model"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "输入型号..."
    },
    model: {
      value: _vm.formItem.model,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "model", $$v);
      },
      expression: "formItem.model"
    }
  })], 1), _vm.type === 'raw' ? _c('FormItem', {
    attrs: {
      "label": "用于母液",
      "prop": "usedForSemi"
    }
  }, [_c('i-switch', {
    model: {
      value: _vm.formItem.usedForSemi,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "usedForSemi", $$v);
      },
      expression: "formItem.usedForSemi"
    }
  })], 1) : _vm._e(), _vm.type === 'raw' ? _c('FormItem', {
    attrs: {
      "label": "用于复配",
      "prop": "usedForProduct"
    }
  }, [_c('i-switch', {
    model: {
      value: _vm.formItem.usedForProduct,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "usedForProduct", $$v);
      },
      expression: "formItem.usedForProduct"
    }
  })], 1) : _vm._e(), _c('FormItem', {
    attrs: {
      "label": "禁用",
      "prop": "invalid"
    }
  }, [_c('i-switch', {
    attrs: {
      "true-color": "#ff4949"
    },
    on: {
      "on-change": _vm.changeInvalid
    },
    model: {
      value: _vm.isInvalid,
      callback: function ($$v) {
        _vm.isInvalid = $$v;
      },
      expression: "isInvalid"
    }
  })], 1), _c('FormItem', {
    attrs: {
      "label": "用于工厂",
      "prop": "usedInFactory"
    }
  }, [_c('Select', {
    attrs: {
      "multiple": "",
      "filterable": ""
    },
    model: {
      value: _vm.formItem.usedInFactory,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "usedInFactory", $$v);
      },
      expression: "formItem.usedInFactory"
    }
  }, _vm._l(_vm.factoryList, function (factory) {
    return _c('Option', {
      key: factory._id,
      attrs: {
        "value": factory._id
      }
    }, [_vm._v(_vm._s(factory.name))]);
  }), 1)], 1), _c('FormItem', {
    attrs: {
      "label": "备注",
      "prop": "remark"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "placeholder": "产品备注"
    },
    model: {
      value: _vm.formItem.remark,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "remark", $$v);
      },
      expression: "formItem.remark"
    }
  })], 1), _c('FormItem', [_c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.handleSubmit('formItem');
      }
    }
  }, [_vm._v("保存")])], 1)], 1)], 1)]);

}
var staticRenderFns = []

export { render, staticRenderFns }